// kapigen version 0.1.34
// eslint-disable
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
import { PrivatedModerationStatusWireFormat3 as KaggleSdkAbusePrivatedModerationStatusWireFormat3 } from "../abuse";
import { DiskUsageLimitsWireFormat3 as KaggleSdkCommonDiskUsageLimitsWireFormat3, VoteTypeWireFormat3 as KaggleSdkCommonVoteTypeWireFormat3 } from "../common";
import { AutoGeneratedSourceWireFormat3 as KaggleSdkDatasetsAutoGeneratedSourceWireFormat3, DatabundleVersionStatusWireFormat3 as KaggleSdkDatasetsDatabundleVersionStatusWireFormat3, DatabundleVersionTypeWireFormat3 as KaggleSdkDatasetsDatabundleVersionTypeWireFormat3, DataCreationBasicInfoWireFormat3 as KaggleSdkDatasetsDataCreationBasicInfoWireFormat3, ExistingDataInfoWireFormat3 as KaggleSdkDatasetsExistingDataInfoWireFormat3, ExistingDirectoryInfoWireFormat3 as KaggleSdkDatasetsExistingDirectoryInfoWireFormat3, ExistingFileInfoWireFormat3 as KaggleSdkDatasetsExistingFileInfoWireFormat3, LicenseGroupDtoWireFormat3 as KaggleSdkDatasetsLicenseGroupDtoWireFormat3, LicenseWireFormat3 as KaggleSdkDatasetsLicenseWireFormat3 } from "../datasets";
import { TagListWireFormat3 as KaggleSdkTagsTagListWireFormat3, TagWireFormat3 as KaggleSdkTagsTagWireFormat3 } from "../tags";
import { CollaboratorListWireFormat3 as KaggleSdkUsersCollaboratorListWireFormat3, UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3, UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3 } from "../users";
export var AddModelTagRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CreateModelInstanceRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.instance) {
            wireFormat.instance = ModelInstanceWireFormat3.toJson(message.instance);
        }
        if (message === null || message === void 0 ? void 0 : message.basicInfo) {
            wireFormat.basicInfo = KaggleSdkDatasetsDataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
        }
        return wireFormat;
    }
};
export var CreateModelInstanceVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.framework) {
            wireFormat.framework = ModelFrameworkWireFormat3.toJson(message.framework);
        }
        if (message === null || message === void 0 ? void 0 : message.basicInfo) {
            wireFormat.basicInfo = KaggleSdkDatasetsDataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.existingDirectories) {
            wireFormat.existingDirectories = message.existingDirectories.map(function(i) {
                return KaggleSdkDatasetsExistingDirectoryInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.existingFiles) {
            wireFormat.existingFiles = message.existingFiles.map(function(i) {
                return KaggleSdkDatasetsExistingFileInfoWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var CreateModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.model) {
            wireFormat.model = ModelWireFormat3.toJson(message.model);
        }
        return wireFormat;
    }
};
export var DeleteModelInstanceRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteModelInstanceResponse = {};
export var DeleteModelInstanceResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteModelInstanceResponse, wireFormat);
        return message;
    }
};
export var DeleteModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteModelResponse = {};
export var DeleteModelResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteModelResponse, wireFormat);
        return message;
    }
};
export var GetModelByIdRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var GetModelInstanceHistoryRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetModelInstanceHistoryResponse = {
    items: [],
    totalItems: 0
};
export var GetModelInstanceHistoryResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetModelInstanceHistoryResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
            message.items = wireFormat.items.map(function(i) {
                return ModelInstanceHistoryItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetModelInstanceRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetModelInstanceUploaderConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetModelInstanceVersionKernelUsageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetModelInstanceVersionKernelUsageResponse = {
    renderedUsage: ""
};
export var GetModelInstanceVersionKernelUsageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetModelInstanceVersionKernelUsageResponse, wireFormat);
        return message;
    }
};
export var GetModelLimitsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        if (message === null || message === void 0 ? void 0 : message.framework) {
            wireFormat.framework = ModelFrameworkWireFormat3.toJson(message.framework);
        }
        return wireFormat;
    }
};
export var GetTfHubRedirectRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetTfHubRedirectResponse = {};
export var GetTfHubRedirectResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetTfHubRedirectResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tfHubRedirect) {
            message.tfHubRedirect = TfHubRedirectWireFormat3.fromJson(wireFormat.tfHubRedirect);
        }
        return message;
    }
};
export var IncrementModelViewCountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultLicensePost = {
    id: 0,
    content: ""
};
export var LicensePostWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLicensePost, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListCompetitionModelInstance = {
    modelInstanceId: 0,
    bestPublicScore: 0,
    numDistinctAuthors: 0,
    modelSubtitle: "",
    modelTitle: "",
    currentVariationSlug: "",
    modelInstanceUrl: "",
    downloadUrl: ""
};
export var ListCompetitionModelInstanceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListCompetitionModelInstance, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestPublicScore) != undefined) {
            message.bestPublicScore = Number(wireFormat.bestPublicScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
            message.owner = OwnerWireFormat3.fromJson(wireFormat.owner);
        }
        if (wireFormat) {
            message.framework = ModelFrameworkWireFormat3.fromJson(wireFormat.framework);
        }
        return message;
    }
};
export var ListCompetitionModelInstancesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.orderBy) {
            wireFormat.orderBy = ListCompetitionModelInstancesOrderByWireFormat3.toJson(message.orderBy);
        }
        return wireFormat;
    }
};
var defaultListCompetitionModelInstancesResponse = {
    pinnedModelInstances: [],
    unpinnedModelInstances: [],
    nextPageToken: ""
};
export var ListCompetitionModelInstancesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListCompetitionModelInstancesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pinnedModelInstances) {
            message.pinnedModelInstances = wireFormat.pinnedModelInstances.map(function(i) {
                return ListCompetitionModelInstanceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.unpinnedModelInstances) {
            message.unpinnedModelInstances = wireFormat.unpinnedModelInstances.map(function(i) {
                return ListCompetitionModelInstanceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListModelInstancesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.framework) {
            wireFormat.framework = ModelFrameworkWireFormat3.toJson(message.framework);
        }
        return wireFormat;
    }
};
var defaultListModelInstancesResponse = {
    instances: []
};
export var ListModelInstancesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListModelInstancesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.instances) {
            message.instances = wireFormat.instances.map(function(i) {
                return ModelInstanceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListModelInstanceVersionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ListModelsFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.framework) {
            wireFormat.framework = ModelFrameworkWireFormat3.toJson(message.framework);
        }
        if (message === null || message === void 0 ? void 0 : message.minBytes) {
            wireFormat.minBytes = message.minBytes.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.maxBytes) {
            wireFormat.maxBytes = message.maxBytes.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.license) {
            wireFormat.license = ModelLicenseWireFormat3.toJson(message.license);
        }
        if ((message === null || message === void 0 ? void 0 : message.minUsabilityRating) != undefined && (message === null || message === void 0 ? void 0 : message.minUsabilityRating) != 0) {
            wireFormat.minUsabilityRating = Number.isFinite(message.minUsabilityRating) ? message.minUsabilityRating : Number(message.minUsabilityRating).toString();
        }
        return wireFormat;
    }
};
export var ListModelsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.filter) {
            wireFormat.filter = ListModelsFilterWireFormat3.toJson(message.filter);
        }
        if (message === null || message === void 0 ? void 0 : message.orderBy) {
            wireFormat.orderBy = ListModelsOrderByWireFormat3.toJson(message.orderBy);
        }
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
var defaultListModelsResponse = {
    models: [],
    nextPageToken: "",
    totalResults: 0,
    totalModelInstances: 0
};
export var ListModelsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListModelsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.models) {
            message.models = wireFormat.models.map(function(i) {
                return ModelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalResults) {
            message.totalResults = parseInt(wireFormat.totalResults);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalModelInstances) {
            message.totalModelInstances = parseInt(wireFormat.totalModelInstances);
        }
        return message;
    }
};
export var ListOwnersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListOwnersResponse = {
    owners: [],
    totalSize: 0
};
export var ListOwnersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListOwnersResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owners) {
            message.owners = wireFormat.owners.map(function(i) {
                return OwnerWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListSampleTasksRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListSampleTasksResponse = {
    tasks: []
};
export var ListSampleTasksResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListSampleTasksResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tasks) {
            message.tasks = wireFormat.tasks.map(function(i) {
                return SampleTaskWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultModel = {
    id: 0,
    versionId: 0,
    licenseGroups: [],
    voters: [],
    frameworks: [],
    instances: [],
    autoGeneratedSources: [],
    authors: []
};
export var ModelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModel, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
            message.owner = OwnerWireFormat3.fromJson(wireFormat.owner);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseGroups) {
            message.licenseGroups = wireFormat.licenseGroups.map(function(i) {
                return KaggleSdkDatasetsLicenseGroupDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voters) {
            message.voters = wireFormat.voters.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.frameworks) {
            message.frameworks = wireFormat.frameworks.map(function(i) {
                return ModelFrameworkWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.instances) {
            message.instances = wireFormat.instances.map(function(i) {
                return ModelInstanceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updateTime) {
            message.updateTime = new Date(wireFormat.updateTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.createTime) {
            message.createTime = new Date(wireFormat.createTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publishTime) {
            message.publishTime = new Date(wireFormat.publishTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.activitySummary) {
            message.activitySummary = ModelActivitySummaryWireFormat3.fromJson(wireFormat.activitySummary);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.notebookCount) {
            message.notebookCount = parseInt(wireFormat.notebookCount);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.hotnessScore) != undefined) {
            message.hotnessScore = Number(wireFormat.hotnessScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.autoGeneratedSources) {
            message.autoGeneratedSources = wireFormat.autoGeneratedSources.map(function(i) {
                return KaggleSdkDatasetsAutoGeneratedSourceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = KaggleSdkTagsTagListWireFormat3.fromJson(wireFormat.categories);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.authors) {
            message.authors = wireFormat.authors.map(function(i) {
                return ModelAuthorWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.fromJson(wireFormat.moderationStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.readMask) {
            message.readMask = {
                "paths": wireFormat.readMask.split(",")
            };
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaboratorList) {
            message.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaboratorList);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) != undefined) {
            message.usabilityRating = Number(wireFormat.usabilityRating);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilitySubscores) {
            message.usabilitySubscores = ModelUsabilityRatingWireFormat3.fromJson(wireFormat.usabilitySubscores);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.owner) {
            wireFormat.owner = OwnerWireFormat3.toJson(message.owner);
        }
        if (message === null || message === void 0 ? void 0 : message.licenseGroups) {
            wireFormat.licenseGroups = message.licenseGroups.map(function(i) {
                return KaggleSdkDatasetsLicenseGroupDtoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.voters) {
            wireFormat.voters = message.voters.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.frameworks) {
            wireFormat.frameworks = message.frameworks.map(function(i) {
                return ModelFrameworkWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.instances) {
            wireFormat.instances = message.instances.map(function(i) {
                return ModelInstanceWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.updateTime) {
            wireFormat.updateTime = message.updateTime.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.createTime) {
            wireFormat.createTime = message.createTime.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.publishTime) {
            wireFormat.publishTime = message.publishTime.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.activitySummary) {
            wireFormat.activitySummary = ModelActivitySummaryWireFormat3.toJson(message.activitySummary);
        }
        if (message === null || message === void 0 ? void 0 : message.notebookCount) {
            wireFormat.notebookCount = message.notebookCount.toString();
        }
        if ((message === null || message === void 0 ? void 0 : message.hotnessScore) != undefined && (message === null || message === void 0 ? void 0 : message.hotnessScore) != 0) {
            wireFormat.hotnessScore = Number.isFinite(message.hotnessScore) ? message.hotnessScore : Number(message.hotnessScore).toString();
        }
        if (message === null || message === void 0 ? void 0 : message.autoGeneratedSources) {
            wireFormat.autoGeneratedSources = message.autoGeneratedSources.map(function(i) {
                return KaggleSdkDatasetsAutoGeneratedSourceWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.categories) {
            wireFormat.categories = KaggleSdkTagsTagListWireFormat3.toJson(message.categories);
        }
        if (message === null || message === void 0 ? void 0 : message.authors) {
            wireFormat.authors = message.authors.map(function(i) {
                return ModelAuthorWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.moderationStatus) {
            wireFormat.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.toJson(message.moderationStatus);
        }
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        if (message === null || message === void 0 ? void 0 : message.collaboratorList) {
            wireFormat.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaboratorList);
        }
        if ((message === null || message === void 0 ? void 0 : message.usabilityRating) != undefined && (message === null || message === void 0 ? void 0 : message.usabilityRating) != 0) {
            wireFormat.usabilityRating = Number.isFinite(message.usabilityRating) ? message.usabilityRating : Number(message.usabilityRating).toString();
        }
        if (message === null || message === void 0 ? void 0 : message.usabilitySubscores) {
            wireFormat.usabilitySubscores = ModelUsabilityRatingWireFormat3.toJson(message.usabilitySubscores);
        }
        return wireFormat;
    }
};
var defaultModelActivityStat = {
    value: 0
};
export var ModelActivityStatWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelActivityStat, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.value) != undefined) {
            message.value = Number(wireFormat.value);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if ((message === null || message === void 0 ? void 0 : message.value) != undefined && (message === null || message === void 0 ? void 0 : message.value) != 0) {
            wireFormat.value = Number.isFinite(message.value) ? message.value : Number(message.value).toString();
        }
        return wireFormat;
    }
};
var defaultModelActivitySummary = {
    id: 0,
    schemaVersion: 0,
    modelStats: [],
    kernelStats: [],
    discussionStats: [],
    topContributors: [],
    timeSeries: {}
};
export var ModelActivitySummaryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelActivitySummary, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.generatedDate) {
            message.generatedDate = new Date(wireFormat.generatedDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelStats) {
            message.modelStats = wireFormat.modelStats.map(function(i) {
                return ModelActivityStatWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelStats) {
            message.kernelStats = wireFormat.kernelStats.map(function(i) {
                return ModelActivityStatWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussionStats) {
            message.discussionStats = wireFormat.discussionStats.map(function(i) {
                return ModelActivityStatWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topContributors) {
            message.topContributors = wireFormat.topContributors.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.timeSeries) {
            message.timeSeries = {};
            Object.entries(wireFormat.timeSeries).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                message.timeSeries[key] = ModelActivityTimeSeriesWireFormat3.fromJson(value);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.generatedDate) {
            wireFormat.generatedDate = message.generatedDate.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.modelStats) {
            wireFormat.modelStats = message.modelStats.map(function(i) {
                return ModelActivityStatWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.kernelStats) {
            wireFormat.kernelStats = message.kernelStats.map(function(i) {
                return ModelActivityStatWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.discussionStats) {
            wireFormat.discussionStats = message.discussionStats.map(function(i) {
                return ModelActivityStatWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.topContributors) {
            wireFormat.topContributors = message.topContributors.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.timeSeries) {
            wireFormat.timeSeries = {};
            Object.entries(message.timeSeries).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                if (value) {
                    wireFormat.timeSeries[key] = ModelActivityTimeSeriesWireFormat3.toJson(value);
                }
            });
        }
        return wireFormat;
    }
};
var defaultModelActivityTimeSeries = {
    points: []
};
export var ModelActivityTimeSeriesWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelActivityTimeSeries, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.points) {
            message.points = wireFormat.points.map(function(i) {
                return ModelActivityTimeSeriesPointWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.points) {
            wireFormat.points = message.points.map(function(i) {
                return ModelActivityTimeSeriesPointWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultModelActivityTimeSeriesPoint = {
    count: 0
};
export var ModelActivityTimeSeriesPointWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelActivityTimeSeriesPoint, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.date) {
            wireFormat.date = message.date.toISOString();
        }
        return wireFormat;
    }
};
var defaultModelAuthor = {};
export var ModelAuthorWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelAuthor, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultModelDto = {
    isNewTopic: false
};
export var ModelDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.model) {
            message.model = ModelWireFormat3.fromJson(wireFormat.model);
        }
        if (wireFormat) {
            message.currentTab = ModelTabWireFormat3.fromJson(wireFormat.currentTab);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.framework) != undefined) {
            message.framework = ModelFrameworkWireFormat3.fromJson(wireFormat.framework);
        }
        return message;
    }
};
var defaultModelInstance = {
    id: 0,
    ownerSlug: "",
    modelSlug: "",
    slug: "",
    versionId: 0,
    overview: "",
    usage: "",
    renderedUsage: "",
    versionNumber: 0,
    versionNotes: "",
    databundleId: 0,
    databundleVersionId: 0,
    firestorePath: "",
    trainingData: []
};
export var ModelInstanceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstance, wireFormat);
        if (wireFormat) {
            message.framework = ModelFrameworkWireFormat3.fromJson(wireFormat.framework);
        }
        if (wireFormat) {
            message.databundleVersionType = KaggleSdkDatasetsDatabundleVersionTypeWireFormat3.fromJson(wireFormat.databundleVersionType);
        }
        if (wireFormat) {
            message.status = KaggleSdkDatasetsDatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sourceOrganization) {
            message.sourceOrganization = OwnerWireFormat3.fromJson(wireFormat.sourceOrganization);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licensePost) {
            message.licensePost = LicensePostWireFormat3.fromJson(wireFormat.licensePost);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.license) {
            message.license = KaggleSdkDatasetsLicenseWireFormat3.fromJson(wireFormat.license);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.framework) {
            wireFormat.framework = ModelFrameworkWireFormat3.toJson(message.framework);
        }
        if (message === null || message === void 0 ? void 0 : message.databundleVersionType) {
            wireFormat.databundleVersionType = KaggleSdkDatasetsDatabundleVersionTypeWireFormat3.toJson(message.databundleVersionType);
        }
        if (message === null || message === void 0 ? void 0 : message.status) {
            wireFormat.status = KaggleSdkDatasetsDatabundleVersionStatusWireFormat3.toJson(message.status);
        }
        if (message === null || message === void 0 ? void 0 : message.sourceOrganization) {
            wireFormat.sourceOrganization = OwnerWireFormat3.toJson(message.sourceOrganization);
        }
        if (message === null || message === void 0 ? void 0 : message.licensePost) {
            wireFormat.licensePost = LicensePostWireFormat3.toJson(message.licensePost);
        }
        if (message === null || message === void 0 ? void 0 : message.license) {
            wireFormat.license = KaggleSdkDatasetsLicenseWireFormat3.toJson(message.license);
        }
        return wireFormat;
    }
};
var defaultModelInstanceHistoryItem = {
    changes: []
};
export var ModelInstanceHistoryItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceHistoryItem, wireFormat);
        if (wireFormat) {
            message.type = ModelInstanceActivityTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
            message.user = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.user);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.changes) {
            message.changes = wireFormat.changes.map(function(i) {
                return ModelInstanceSchemaDiffWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.summary) {
            message.summary = ModelInstanceSchemaDiffSummaryWireFormat3.fromJson(wireFormat.summary);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versionInfo) {
            message.versionInfo = ModelInstanceHistoryVersionInfoWireFormat3.fromJson(wireFormat.versionInfo);
        }
        return message;
    }
};
var defaultModelInstanceHistoryVersionInfo = {
    databundleVersionId: 0
};
export var ModelInstanceHistoryVersionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceHistoryVersionInfo, wireFormat);
        if (wireFormat) {
            message.status = KaggleSdkDatasetsDatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
        }
        return message;
    }
};
var defaultModelInstanceSchemaDiff = {
    schemaVersion: 0
};
export var ModelInstanceSchemaDiffWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceSchemaDiff, wireFormat);
        if (wireFormat) {
            message.action = ModelInstanceSchemaDiffActionWireFormat3.fromJson(wireFormat.action);
        }
        if (wireFormat) {
            message.level = ModelInstanceSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.level);
        }
        if (wireFormat) {
            message.parentLevel = ModelInstanceSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.parentLevel);
        }
        return message;
    }
};
var defaultModelInstanceSchemaDiffSummary = {
    addedCount: 0,
    modifiedCount: 0,
    deletedCount: 0,
    totalChangedEntities: 0,
    changedEntities: []
};
export var ModelInstanceSchemaDiffSummaryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceSchemaDiffSummary, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.changedEntities) {
            message.changedEntities = wireFormat.changedEntities.map(function(i) {
                return ModelInstanceSchemaEntityWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultModelInstanceSchemaEntity = {};
export var ModelInstanceSchemaEntityWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceSchemaEntity, wireFormat);
        if (wireFormat) {
            message.level = ModelInstanceSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.level);
        }
        return message;
    }
};
var defaultModelInstanceVersion = {
    id: 0,
    isTfhubModel: false,
    url: "",
    variationSlug: "",
    versionNumber: 0,
    modelTitle: "",
    thumbnailUrl: "",
    isPrivate: false
};
export var ModelInstanceVersionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceVersion, wireFormat);
        if (wireFormat) {
            message.framework = ModelFrameworkWireFormat3.fromJson(wireFormat.framework);
        }
        return message;
    }
};
var defaultModelInstanceVersionList = {
    versions: []
};
export var ModelInstanceVersionListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceVersionList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versions) {
            message.versions = wireFormat.versions.map(function(i) {
                return ModelInstanceVersionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultModelUploaderConfig = {};
export var ModelUploaderConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelUploaderConfig, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingData) {
            message.existingData = KaggleSdkDatasetsExistingDataInfoWireFormat3.fromJson(wireFormat.existingData);
        }
        return message;
    }
};
var defaultModelUsabilityRating = {
    score: 0,
    documentationScore: 0,
    provenanceScore: 0,
    publicKernelScore: 0,
    subtitleScore: 0,
    tagScore: 0
};
export var ModelUsabilityRatingWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelUsabilityRating, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.score) != undefined) {
            message.score = Number(wireFormat.score);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.documentationScore) != undefined) {
            message.documentationScore = Number(wireFormat.documentationScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.provenanceScore) != undefined) {
            message.provenanceScore = Number(wireFormat.provenanceScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicKernelScore) != undefined) {
            message.publicKernelScore = Number(wireFormat.publicKernelScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.subtitleScore) != undefined) {
            message.subtitleScore = Number(wireFormat.subtitleScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tagScore) != undefined) {
            message.tagScore = Number(wireFormat.tagScore);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if ((message === null || message === void 0 ? void 0 : message.score) != undefined && (message === null || message === void 0 ? void 0 : message.score) != 0) {
            wireFormat.score = Number.isFinite(message.score) ? message.score : Number(message.score).toString();
        }
        if ((message === null || message === void 0 ? void 0 : message.documentationScore) != undefined && (message === null || message === void 0 ? void 0 : message.documentationScore) != 0) {
            wireFormat.documentationScore = Number.isFinite(message.documentationScore) ? message.documentationScore : Number(message.documentationScore).toString();
        }
        if ((message === null || message === void 0 ? void 0 : message.provenanceScore) != undefined && (message === null || message === void 0 ? void 0 : message.provenanceScore) != 0) {
            wireFormat.provenanceScore = Number.isFinite(message.provenanceScore) ? message.provenanceScore : Number(message.provenanceScore).toString();
        }
        if ((message === null || message === void 0 ? void 0 : message.publicKernelScore) != undefined && (message === null || message === void 0 ? void 0 : message.publicKernelScore) != 0) {
            wireFormat.publicKernelScore = Number.isFinite(message.publicKernelScore) ? message.publicKernelScore : Number(message.publicKernelScore).toString();
        }
        if ((message === null || message === void 0 ? void 0 : message.subtitleScore) != undefined && (message === null || message === void 0 ? void 0 : message.subtitleScore) != 0) {
            wireFormat.subtitleScore = Number.isFinite(message.subtitleScore) ? message.subtitleScore : Number(message.subtitleScore).toString();
        }
        if ((message === null || message === void 0 ? void 0 : message.tagScore) != undefined && (message === null || message === void 0 ? void 0 : message.tagScore) != 0) {
            wireFormat.tagScore = Number.isFinite(message.tagScore) ? message.tagScore : Number(message.tagScore).toString();
        }
        return wireFormat;
    }
};
var defaultOwner = {
    id: 0,
    isOrganization: false,
    name: "",
    slug: ""
};
export var OwnerWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOwner, wireFormat);
        if (wireFormat) {
            message.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.userTier);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.userTier) {
            wireFormat.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.toJson(message.userTier);
        }
        return wireFormat;
    }
};
export var PinModelInstanceToCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var RecreateModelInstanceVersionArchiveRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultRecreateModelInstanceVersionArchiveResponse = {
    databundleVersionId: 0
};
export var RecreateModelInstanceVersionArchiveResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRecreateModelInstanceVersionArchiveResponse, wireFormat);
        return message;
    }
};
export var RemoveModelTagRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSampleTask = {
    thumbnailPath: ""
};
export var SampleTaskWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSampleTask, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tag) {
            message.tag = KaggleSdkTagsTagWireFormat3.fromJson(wireFormat.tag);
        }
        return message;
    }
};
export var SetTfHubRedirectRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.tfHubRedirect) {
            wireFormat.tfHubRedirect = TfHubRedirectWireFormat3.toJson(message.tfHubRedirect);
        }
        return wireFormat;
    }
};
var defaultSetTfHubRedirectResponse = {};
export var SetTfHubRedirectResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSetTfHubRedirectResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tfHubRedirect) {
            message.tfHubRedirect = TfHubRedirectWireFormat3.fromJson(wireFormat.tfHubRedirect);
        }
        return message;
    }
};
var defaultTfHubRedirect = {
    tfHubPath: ""
};
export var TfHubRedirectWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTfHubRedirect, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
export var UnpinModelInstanceFromCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateModelCollaboratorsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.collaborators) {
            wireFormat.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaborators);
        }
        return wireFormat;
    }
};
export var UpdateModelInstanceRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.instance) {
            wireFormat.instance = ModelInstanceWireFormat3.toJson(message.instance);
        }
        if (message === null || message === void 0 ? void 0 : message.updateMask) {
            var _paths;
            wireFormat.updateMask = ((_paths = message.updateMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var UpdateModelOwnerRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateModelOwnerResponse = {
    newUrl: ""
};
export var UpdateModelOwnerResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateModelOwnerResponse, wireFormat);
        return message;
    }
};
export var UpdateModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.model) {
            wireFormat.model = ModelWireFormat3.toJson(message.model);
        }
        if (message === null || message === void 0 ? void 0 : message.updateMask) {
            var _paths;
            wireFormat.updateMask = ((_paths = message.updateMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var VoteOnModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.voteType) {
            wireFormat.voteType = KaggleSdkCommonVoteTypeWireFormat3.toJson(message.voteType);
        }
        return wireFormat;
    }
};
export var ListCompetitionModelInstancesOrderBy;
(function(ListCompetitionModelInstancesOrderBy) {
    ListCompetitionModelInstancesOrderBy["NUMBER_OF_UNIQUE_USERS"] = "numberOfUniqueUsers";
    ListCompetitionModelInstancesOrderBy["BEST_NOTEBOOK_SCORE"] = "bestNotebookScore";
})(ListCompetitionModelInstancesOrderBy || (ListCompetitionModelInstancesOrderBy = {}));
export var ListCompetitionModelInstancesOrderByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ListCompetitionModelInstancesOrderBy.NUMBER_OF_UNIQUE_USERS:
            case 0:
            default:
                return "NUMBER_OF_UNIQUE_USERS";
            case ListCompetitionModelInstancesOrderBy.BEST_NOTEBOOK_SCORE:
            case 1:
                return "BEST_NOTEBOOK_SCORE";
        }
    }
};
export var ListModelsOrderBy;
(function(ListModelsOrderBy) {
    ListModelsOrderBy["UNSPECIFIED"] = "unspecified";
    ListModelsOrderBy["HOTNESS"] = "hotness";
    ListModelsOrderBy["DOWNLOAD_COUNT"] = "downloadCount";
    ListModelsOrderBy["VOTE_COUNT"] = "voteCount";
    ListModelsOrderBy["NOTEBOOK_COUNT"] = "notebookCount";
    ListModelsOrderBy["PUBLISH_TIME"] = "publishTime";
    ListModelsOrderBy["CREATE_TIME"] = "createTime";
    ListModelsOrderBy["UPDATE_TIME"] = "updateTime";
    ListModelsOrderBy["VIEW_TIME_DESC"] = "viewTimeDesc";
})(ListModelsOrderBy || (ListModelsOrderBy = {}));
export var ListModelsOrderByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ListModelsOrderBy.UNSPECIFIED:
            case 0:
            default:
                return "LIST_MODELS_ORDER_BY_UNSPECIFIED";
            case ListModelsOrderBy.HOTNESS:
            case 1:
                return "LIST_MODELS_ORDER_BY_HOTNESS";
            case ListModelsOrderBy.DOWNLOAD_COUNT:
            case 2:
                return "LIST_MODELS_ORDER_BY_DOWNLOAD_COUNT";
            case ListModelsOrderBy.VOTE_COUNT:
            case 3:
                return "LIST_MODELS_ORDER_BY_VOTE_COUNT";
            case ListModelsOrderBy.NOTEBOOK_COUNT:
            case 4:
                return "LIST_MODELS_ORDER_BY_NOTEBOOK_COUNT";
            case ListModelsOrderBy.PUBLISH_TIME:
            case 5:
                return "LIST_MODELS_ORDER_BY_PUBLISH_TIME";
            case ListModelsOrderBy.CREATE_TIME:
            case 6:
                return "LIST_MODELS_ORDER_BY_CREATE_TIME";
            case ListModelsOrderBy.UPDATE_TIME:
            case 7:
                return "LIST_MODELS_ORDER_BY_UPDATE_TIME";
            case ListModelsOrderBy.VIEW_TIME_DESC:
            case 8:
                return "LIST_MODELS_ORDER_BY_VIEW_TIME_DESC";
        }
    }
};
export var ModelFramework;
(function(ModelFramework) {
    ModelFramework["UNSPECIFIED"] = "unspecified";
    ModelFramework["TENSOR_FLOW_1"] = "tensorFlow1";
    ModelFramework["TENSOR_FLOW_2"] = "tensorFlow2";
    ModelFramework["TF_LITE"] = "tfLite";
    ModelFramework["TF_JS"] = "tfJs";
    ModelFramework["PY_TORCH"] = "pyTorch";
    ModelFramework["JAX"] = "jax";
    ModelFramework["CORAL"] = "coral";
    ModelFramework["SCIKIT_LEARN"] = "scikitLearn";
    ModelFramework["MXNET"] = "mxnet";
    ModelFramework["ONNX"] = "onnx";
    ModelFramework["KERAS"] = "keras";
})(ModelFramework || (ModelFramework = {}));
export var ModelFrameworkWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "MODEL_FRAMEWORK_UNSPECIFIED":
            default:
                return ModelFramework.UNSPECIFIED;
            case "MODEL_FRAMEWORK_TENSOR_FLOW_1":
                return ModelFramework.TENSOR_FLOW_1;
            case "MODEL_FRAMEWORK_TENSOR_FLOW_2":
                return ModelFramework.TENSOR_FLOW_2;
            case "MODEL_FRAMEWORK_TF_LITE":
                return ModelFramework.TF_LITE;
            case "MODEL_FRAMEWORK_TF_JS":
                return ModelFramework.TF_JS;
            case "MODEL_FRAMEWORK_PY_TORCH":
                return ModelFramework.PY_TORCH;
            case "MODEL_FRAMEWORK_JAX":
                return ModelFramework.JAX;
            case "MODEL_FRAMEWORK_CORAL":
                return ModelFramework.CORAL;
            case "MODEL_FRAMEWORK_SCIKIT_LEARN":
                return ModelFramework.SCIKIT_LEARN;
            case "MODEL_FRAMEWORK_MXNET":
                return ModelFramework.MXNET;
            case "MODEL_FRAMEWORK_ONNX":
                return ModelFramework.ONNX;
            case "MODEL_FRAMEWORK_KERAS":
                return ModelFramework.KERAS;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ModelFramework.UNSPECIFIED:
            case 0:
            default:
                return "MODEL_FRAMEWORK_UNSPECIFIED";
            case ModelFramework.TENSOR_FLOW_1:
            case 1:
                return "MODEL_FRAMEWORK_TENSOR_FLOW_1";
            case ModelFramework.TENSOR_FLOW_2:
            case 2:
                return "MODEL_FRAMEWORK_TENSOR_FLOW_2";
            case ModelFramework.TF_LITE:
            case 3:
                return "MODEL_FRAMEWORK_TF_LITE";
            case ModelFramework.TF_JS:
            case 4:
                return "MODEL_FRAMEWORK_TF_JS";
            case ModelFramework.PY_TORCH:
            case 5:
                return "MODEL_FRAMEWORK_PY_TORCH";
            case ModelFramework.JAX:
            case 6:
                return "MODEL_FRAMEWORK_JAX";
            case ModelFramework.CORAL:
            case 7:
                return "MODEL_FRAMEWORK_CORAL";
            case ModelFramework.SCIKIT_LEARN:
            case 8:
                return "MODEL_FRAMEWORK_SCIKIT_LEARN";
            case ModelFramework.MXNET:
            case 9:
                return "MODEL_FRAMEWORK_MXNET";
            case ModelFramework.ONNX:
            case 10:
                return "MODEL_FRAMEWORK_ONNX";
            case ModelFramework.KERAS:
            case 11:
                return "MODEL_FRAMEWORK_KERAS";
        }
    }
};
export var ModelInstanceActivityType;
(function(ModelInstanceActivityType) {
    ModelInstanceActivityType["UNSPECIFIED"] = "unspecified";
    ModelInstanceActivityType["CREATE"] = "create";
    ModelInstanceActivityType["NEW_VERSION"] = "newVersion";
    ModelInstanceActivityType["REMOVE"] = "remove";
    ModelInstanceActivityType["REMOVE_VERSION"] = "removeVersion";
})(ModelInstanceActivityType || (ModelInstanceActivityType = {}));
export var ModelInstanceActivityTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "MODEL_INSTANCE_ACTIVITY_TYPE_UNSPECIFIED":
            default:
                return ModelInstanceActivityType.UNSPECIFIED;
            case "MODEL_INSTANCE_ACTIVITY_TYPE_CREATE":
                return ModelInstanceActivityType.CREATE;
            case "MODEL_INSTANCE_ACTIVITY_TYPE_NEW_VERSION":
                return ModelInstanceActivityType.NEW_VERSION;
            case "MODEL_INSTANCE_ACTIVITY_TYPE_REMOVE":
                return ModelInstanceActivityType.REMOVE;
            case "MODEL_INSTANCE_ACTIVITY_TYPE_REMOVE_VERSION":
                return ModelInstanceActivityType.REMOVE_VERSION;
        }
    }
};
export var ModelInstanceSchemaDiffAction;
(function(ModelInstanceSchemaDiffAction) {
    ModelInstanceSchemaDiffAction["ADD"] = "add";
    ModelInstanceSchemaDiffAction["DELETE"] = "delete";
    ModelInstanceSchemaDiffAction["MODIFY_FILE"] = "modifyFile";
})(ModelInstanceSchemaDiffAction || (ModelInstanceSchemaDiffAction = {}));
export var ModelInstanceSchemaDiffActionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "MODEL_INSTANCE_SCHEMA_DIFF_ACTION_ADD":
            default:
                return ModelInstanceSchemaDiffAction.ADD;
            case "MODEL_INSTANCE_SCHEMA_DIFF_ACTION_DELETE":
                return ModelInstanceSchemaDiffAction.DELETE;
            case "MODEL_INSTANCE_SCHEMA_DIFF_ACTION_MODIFY_FILE":
                return ModelInstanceSchemaDiffAction.MODIFY_FILE;
        }
    }
};
export var ModelInstanceSchemaDiffContainerLevel;
(function(ModelInstanceSchemaDiffContainerLevel) {
    ModelInstanceSchemaDiffContainerLevel["UNSPECIFIED"] = "unspecified";
    ModelInstanceSchemaDiffContainerLevel["MODEL_INSTANCE"] = "modelInstance";
    ModelInstanceSchemaDiffContainerLevel[// For now, only detect file-level changes. If we discover that models contain
    // tabular data, we can support it later
    "FILE"] = "file";
})(ModelInstanceSchemaDiffContainerLevel || (ModelInstanceSchemaDiffContainerLevel = {}));
export var ModelInstanceSchemaDiffContainerLevelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "MODEL_INSTANCE_SCHEMA_DIFF_CONTAINER_LEVEL_UNSPECIFIED":
            default:
                return ModelInstanceSchemaDiffContainerLevel.UNSPECIFIED;
            case "MODEL_INSTANCE_SCHEMA_DIFF_CONTAINER_LEVEL_MODEL_INSTANCE":
                return ModelInstanceSchemaDiffContainerLevel.MODEL_INSTANCE;
            case "MODEL_INSTANCE_SCHEMA_DIFF_CONTAINER_LEVEL_FILE":
                return ModelInstanceSchemaDiffContainerLevel.FILE;
        }
    }
};
export var ModelLicense;
(function(ModelLicense) {
    ModelLicense["UNSPECIFIED"] = "unspecified";
    ModelLicense[// Enum int values taken from dbo.Licenses
    "CC0"] = "cc0";
    ModelLicense["APACHE2"] = "apache2";
    ModelLicense["MIT"] = "mit";
    ModelLicense["BSD"] = "bsd";
    ModelLicense["OTHER"] = "other";
})(ModelLicense || (ModelLicense = {}));
export var ModelLicenseWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ModelLicense.UNSPECIFIED:
            case 0:
            default:
                return "UNSPECIFIED";
            case ModelLicense.CC0:
            case 1:
                return "CC0";
            case ModelLicense.APACHE2:
            case 30:
                return "APACHE2";
            case ModelLicense.MIT:
            case 31:
                return "MIT";
            case ModelLicense.BSD:
            case 32:
                return "BSD";
            case ModelLicense.OTHER:
            case 12:
                return "OTHER";
        }
    }
};
export var ModelTab;
(function(ModelTab) {
    ModelTab["MODEL_CARD"] = "modelCard";
    ModelTab["CODE"] = "code";
    ModelTab["DISCUSSION"] = "discussion";
    ModelTab["ADMIN"] = "admin";
    ModelTab["SETTINGS"] = "settings";
})(ModelTab || (ModelTab = {}));
export var ModelTabWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "MODEL_TAB_MODEL_CARD":
            default:
                return ModelTab.MODEL_CARD;
            case "MODEL_TAB_CODE":
                return ModelTab.CODE;
            case "MODEL_TAB_DISCUSSION":
                return ModelTab.DISCUSSION;
            case "MODEL_TAB_ADMIN":
                return ModelTab.ADMIN;
            case "MODEL_TAB_SETTINGS":
                return ModelTab.SETTINGS;
        }
    }
};
export var modelsClient = {
    modelAdminService: {
        getTfHubRedirect: createClient(GetTfHubRedirectRequestWireFormat3, GetTfHubRedirectResponseWireFormat3, "models.ModelAdminService/GetTfHubRedirect"),
        recreateModelInstanceVersionArchive: createClient(RecreateModelInstanceVersionArchiveRequestWireFormat3, RecreateModelInstanceVersionArchiveResponseWireFormat3, "models.ModelAdminService/RecreateModelInstanceVersionArchive"),
        setTfHubRedirect: createClient(SetTfHubRedirectRequestWireFormat3, SetTfHubRedirectResponseWireFormat3, "models.ModelAdminService/SetTfHubRedirect")
    },
    modelService: {
        addModelTag: createClient(AddModelTagRequestWireFormat3, google.protobuf.EmptyWireFormat3, "models.ModelService/AddModelTag"),
        createModel: createClient(CreateModelRequestWireFormat3, ModelWireFormat3, "models.ModelService/CreateModel"),
        createModelInstance: createClient(CreateModelInstanceRequestWireFormat3, ModelInstanceWireFormat3, "models.ModelService/CreateModelInstance"),
        createModelInstanceVersion: createClient(CreateModelInstanceVersionRequestWireFormat3, ModelInstanceWireFormat3, "models.ModelService/CreateModelInstanceVersion"),
        deleteModel: createClient(DeleteModelRequestWireFormat3, DeleteModelResponseWireFormat3, "models.ModelService/DeleteModel"),
        deleteModelInstance: createClient(DeleteModelInstanceRequestWireFormat3, DeleteModelInstanceResponseWireFormat3, "models.ModelService/DeleteModelInstance"),
        getModel: createClient(GetModelRequestWireFormat3, ModelWireFormat3, "models.ModelService/GetModel"),
        getModelById: createClient(GetModelByIdRequestWireFormat3, ModelWireFormat3, "models.ModelService/GetModelById"),
        getModelInstance: createClient(GetModelInstanceRequestWireFormat3, ModelInstanceWireFormat3, "models.ModelService/GetModelInstance"),
        getModelInstanceHistory: createClient(GetModelInstanceHistoryRequestWireFormat3, GetModelInstanceHistoryResponseWireFormat3, "models.ModelService/GetModelInstanceHistory"),
        getModelInstanceUploaderConfig: createClient(GetModelInstanceUploaderConfigRequestWireFormat3, ModelUploaderConfigWireFormat3, "models.ModelService/GetModelInstanceUploaderConfig"),
        getModelInstanceVersionKernelUsage: createClient(GetModelInstanceVersionKernelUsageRequestWireFormat3, GetModelInstanceVersionKernelUsageResponseWireFormat3, "models.ModelService/GetModelInstanceVersionKernelUsage"),
        getModelLimits: createClient(GetModelLimitsRequestWireFormat3, KaggleSdkCommonDiskUsageLimitsWireFormat3, "models.ModelService/GetModelLimits"),
        incrementModelViewCount: createClient(IncrementModelViewCountRequestWireFormat3, google.protobuf.EmptyWireFormat3, "models.ModelService/IncrementModelViewCount"),
        listCompetitionModelInstances: createClient(ListCompetitionModelInstancesRequestWireFormat3, ListCompetitionModelInstancesResponseWireFormat3, "models.ModelService/ListCompetitionModelInstances"),
        listModelInstances: createClient(ListModelInstancesRequestWireFormat3, ListModelInstancesResponseWireFormat3, "models.ModelService/ListModelInstances"),
        listModelInstanceVersions: createClient(ListModelInstanceVersionsRequestWireFormat3, ModelInstanceVersionListWireFormat3, "models.ModelService/ListModelInstanceVersions"),
        listModels: createClient(ListModelsRequestWireFormat3, ListModelsResponseWireFormat3, "models.ModelService/ListModels"),
        listOwners: createClient(ListOwnersRequestWireFormat3, ListOwnersResponseWireFormat3, "models.ModelService/ListOwners"),
        listSampleTasks: createClient(ListSampleTasksRequestWireFormat3, ListSampleTasksResponseWireFormat3, "models.ModelService/ListSampleTasks"),
        pinModelInstanceToCompetition: createClient(PinModelInstanceToCompetitionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "models.ModelService/PinModelInstanceToCompetition"),
        removeModelTag: createClient(RemoveModelTagRequestWireFormat3, google.protobuf.EmptyWireFormat3, "models.ModelService/RemoveModelTag"),
        unpinModelInstanceFromCompetition: createClient(UnpinModelInstanceFromCompetitionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "models.ModelService/UnpinModelInstanceFromCompetition"),
        updateModel: createClient(UpdateModelRequestWireFormat3, ModelWireFormat3, "models.ModelService/UpdateModel"),
        updateModelCollaborators: createClient(UpdateModelCollaboratorsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "models.ModelService/UpdateModelCollaborators"),
        // This RPC is used for updating a model instance metadata (e.g overview,
        // usage, etc.). To upload new files for this instance, use the
        // CreateModelInstanceVersion RPC above.
        updateModelInstance: createClient(UpdateModelInstanceRequestWireFormat3, ModelInstanceWireFormat3, "models.ModelService/UpdateModelInstance"),
        updateModelOwner: createClient(UpdateModelOwnerRequestWireFormat3, UpdateModelOwnerResponseWireFormat3, "models.ModelService/UpdateModelOwner"),
        voteOnModel: createClient(VoteOnModelRequestWireFormat3, google.protobuf.EmptyWireFormat3, "models.ModelService/VoteOnModel")
    }
};
